import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Result, BadInputError } from '@digibricks/core';
export var Pagination = /*#__PURE__*/function () {
  function Pagination(items, nextToken) {
    _classCallCheck(this, Pagination);

    _defineProperty(this, "_items", void 0);

    _defineProperty(this, "_nextToken", void 0);

    this._items = items;
    this._nextToken = nextToken;
  }

  _createClass(Pagination, [{
    key: "items",
    get: function get() {
      return this._items;
    }
  }, {
    key: "nextToken",
    get: function get() {
      return this._nextToken;
    }
  }, {
    key: "updateItems",
    value: function updateItems(items) {
      this._items = _toConsumableArray(items);
      return Result.ok();
    }
  }], [{
    key: "create",
    value: function create(props) {
      if (!Array.isArray(props.items)) {
        return new BadInputError('Items must be an array');
      }

      return Result.ok(new Pagination(props.items, props.nextToken));
    }
  }]);

  return Pagination;
}();